//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "CardVeryMax",
  props: [
    "id",
    "type",
    "category_name",
    "description",
    "title",
    "url",
    "date",
    "announce",
    "image_id",
    "additional_image_1_3",
    "comments_count",
    "type"
  ],
  computed: {
    getDescriptionLength() {
      if (
        (this.description && this.description.length > 200) ||
        (this.text && this.text.length > 200)
      ) {
        return this.description
          ? `${this.description?.substring(0, 200)}...`
          : `${this.text?.substring(0, 200)}...`;
      }
      return this.description ? this.description : this.text;
    },
    setBgColor() {
      let colors = ["bg-[#F1F6F8]", "bg-[#F3EFF1]", "bg-[#F4EFF4]"];
      return colors[Math.floor(Math.random() * colors.length)];
    },
    commentsCounter() {
      return `${this.comments_count} ${this.$caseWords(this.comments_count, [
        "комментарий",
        "комментария",
        "комментариев",
      ])}`;
    },
    linkCharity: function () {
      return this.$store.state.appState?.vars?.['Ссылка на подборку товаров благотворительности'] || ""
    },
    isVisibleButtonCategory: function () {
      if (this.type === "charity") {
        return {
          title: "Поддержать проект",
          url: this.linkCharity
        }
      }
      return null
    },
    isVisibleCountLikes: function () {
      return Boolean(this.type === "charity")
    },
  },
  components: {
    PreviewLikes: () => import("~/components/articles/PreviewLikes")
  },
  methods: {
    onTapCard: function () {
      const url = this.url;

      this.$emit("click", this.url);
    },
  },
};
